
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle, Gauge, CheckCircle } from 'lucide-react';

interface MovementStatusBadgeProps {
  movementBlocked?: boolean;
  speedLimit?: number | null;
  maxAllowedSpeed?: number;
}

export const MovementStatusBadge: React.FC<MovementStatusBadgeProps> = ({
  movementBlocked = false,
  speedLimit,
  maxAllowedSpeed = 25
}) => {
  console.log('=== MovementStatusBadge Debug ===');
  console.log('movementBlocked:', movementBlocked);
  console.log('speedLimit:', speedLimit);
  console.log('maxAllowedSpeed:', maxAllowedSpeed);
  console.log('speedLimit type:', typeof speedLimit);
  
  if (movementBlocked) {
    console.log('Отображаем статус: ЗАБЛОКИРОВАН');
    return (
      <Badge variant="destructive" className="flex items-center gap-1">
        <AlertTriangle className="h-3 w-3" />
        Заблокирован
      </Badge>
    );
  }

  // Упрощенная логика - speedLimit теперь всегда number | null
  const hasSpeedLimit = speedLimit !== null && speedLimit !== undefined && speedLimit > 0;
  
  console.log('Обработанное ограничение скорости:', speedLimit);
  console.log('hasSpeedLimit:', hasSpeedLimit);
  
  if (hasSpeedLimit) {
    console.log('Отображаем статус: ОГРАНИЧЕНИЕ СКОРОСТИ', speedLimit);
    return (
      <Badge variant="warning" className="flex items-center gap-1 bg-yellow-500 text-white hover:bg-yellow-600">
        <Gauge className="h-3 w-3" />
        {speedLimit} км/ч
      </Badge>
    );
  }

  console.log('Отображаем статус: НОРМАЛЬНЫЙ');
  return (
    <Badge variant="outline" className="flex items-center gap-1">
      <CheckCircle className="h-3 w-3" />
      Нормальный
    </Badge>
  );
};
